import secureAxios from '../secure_axios';

const baseUrl = 'formulario-acompanhamento'

async function servPostFormularioAcompanhamento(formularioAcompanhamento) {
    const response = await secureAxios.post(`${baseUrl}`, formularioAcompanhamento)
    return response
}

function servVerificaMesEnvio(estabelecimentoId, mesReferencia) {
    return secureAxios.get(`${baseUrl}/verifica-mes-envio`, {
        params: { mesReferencia, estabelecimentoId }
    }
    );
}

function servVerificaDuplicidade(estabelecimentoId, mesReferencia) {
    return secureAxios.get(`${baseUrl}/verifica-duplicidade`, {
        params: { mesReferencia, estabelecimentoId }
    }
    );
}

function servGetAllOpcaoRespostaFormularioAcompanhamento() {
    return secureAxios.get(`${baseUrl}/opcoes-resposta`);
}

function servGetFormulariosPorMes(mesReferencia, page, estabelecimento) {

    const estabelecimentoId = estabelecimento ? estabelecimento.id : null

    return secureAxios.get(`${baseUrl}/mes`, {
        params: { mesReferencia, page, estabelecimentoId }
    });
}

export {
    servPostFormularioAcompanhamento,
    servVerificaMesEnvio,
    servVerificaDuplicidade,
    servGetAllOpcaoRespostaFormularioAcompanhamento,
    servGetFormulariosPorMes
}
